export const ALLCOUNTRY = 'All Countries';
export const allowRoles: string[] = ['CPak_Affiliate', 'CPak_Contract_Admin', 'CPak_Admin'];
export const ACCOUNT = '/accounts';
export const CATALOG = '/catalog';
export const CURRENTROUT = 'currentRoute';
export const POPSTATE = 'popstate';
export const COUNTRYARRAYLEN = 1;
